import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask, round2Decimals } from "../../Components/Items";
import numeroALetra from "../../Components/numeroALetra";
import { formatQRTotal } from "../../Components/RoundQRDecimals";
import { PDF_COLORS, pdfStylesV2, divisorV2, PDF_PAGE_MARGINS, applyPdfColors } from "../../Components/PdfComponents/componentsv2.0/stylesPDFv2";
import { PDFHeaderV2 } from "../../Components/PdfComponents/componentsv2.0/PDFHeader";
import { PDFClientInfoV2 } from "../../Components/PdfComponents/componentsv2.0/PDFClientInfo";
import { PDFItemsTableV2 } from "../../Components/PdfComponents/componentsv2.0/PDFItemsTable";
import { PDFSummarySectionV2 } from "../../Components/PdfComponents/componentsv2.0/PDFTotalsSummary";
import { PDFPaymentInfoV2 } from "../../Components/PdfComponents/componentsv2.0/PDFPaymentInfo";
import { PDFNotesV2 } from "../../Components/PdfComponents/componentsv2.0/PDFNotes";
import { PDFBrandFooterV2 } from "../../Components/PdfComponents/componentsv2.0/PDFFooter";
import { PDFCfdiFooterV2 } from "../../Components/PdfComponents/componentsv2.0/PDFCfdiFooter";
// Registra la tipografía Mulish en pdfMake (efecto secundario) y expone su nombre.
import MULISH_FONT from "./mulishFont";
// Registra la variante Mulish SemiBold (600) usada en las etiquetas (efecto secundario).
import "./mulishSemiBoldFont";

moment.locale("es");

const facturaGlobalPdfV2 = (values) => {
  const empresa = values.respuestaFactura.empresa;
  const logoBiwo = values.logoBiwo?.base64Completa || values.respuestaFactura?.logoBiwo?.base64Completa;

  applyPdfColors(empresa);

  const dataSat = values.respuestaFactura.dataSat;
  const dataExtra = values.respuestaFactura.data;

  // --- Conceptos (lógica VERBATIM del clásico) ---
  const conceptos = dataSat.Conceptos.map((valueConcepto) => {
    let iva = 0;
    let ieps = 0;
    valueConcepto?.Impuestos?.Traslados?.map((valueImpuesto) => {
      if (valueImpuesto.Impuesto === "002" && valueImpuesto.Importe) {
        iva += valueImpuesto.Importe;
      }
      if (valueImpuesto.Impuesto === "003" && valueImpuesto.Importe) {
        ieps += valueImpuesto.Importe;
      }
      return null;
    });
    return [
      { style: "textoTablaChico", text: valueConcepto.Cantidad, alignment: "right" },
      {
        text: valueConcepto.ClaveUnidad,
        style: "textoTablaChico",
        alignment: "center",
      },
      {
        text: valueConcepto.ClaveProdServ,
        style: "textoTablaChico",
        alignment: "center",
      },
      {
        text: valueConcepto.Descripcion + (valueConcepto.Observaciones ? ("\n" + valueConcepto.Observaciones) : ""),
        style: "textoTablaChico",
        alignment: "left",
      },
      {
        text: dineroDisabledMask(iva),
        style: "textoTablaChico",
        alignment: "right",
      },
      ...(empresa.imprimirIEPS
        ? [
            {
              text: dineroDisabledMask(ieps),
              style: "textoTablaChico",
              alignment: "right",
            },
          ]
        : []),
      {
        text: dineroDisabledMask(valueConcepto.ValorUnitario),
        style: "textoTablaChico",
        alignment: "right",
      },
      {
        text: dineroDisabledMask(valueConcepto.Importe),
        style: "textoTablaChico",
        alignment: "right",
      },
    ];
  });

  // --- Impuestos trasladados (lógica VERBATIM del clásico) ---
  const nuevoArrayImpFL = Array.isArray(dataSat.Impuestos.Traslados) ?
    [...dataSat.Impuestos.Traslados, ...(dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.["implocal:TrasladosLocales"] || [])]
    :
    [...(dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.["implocal:TrasladosLocales"] || [])]

  // Definir orden personalizado
  const ordenImpuestos = ["IVA 0%", "IVA 16%", "IEPS 6%", "IEPS 7%", "IEPS 9%"];

  // Ordenar el array antes del map
  const nuevoArrayImpFLOdenado = [...nuevoArrayImpFL].sort((a, b) => {
    const nombreA = a.Impuesto === "002"
      ? `IVA ${round2Decimals(a.TasaOCuota * 100)}%`
      : a.Impuesto === "003"
        ? `IEPS ${round2Decimals(a.TasaOCuota * 100)}%`
        : a["@ImpLocTrasladado"];
    const nombreB = b.Impuesto === "002"
      ? `IVA ${round2Decimals(b.TasaOCuota * 100)}%`
      : b.Impuesto === "003"
        ? `IEPS ${round2Decimals(b.TasaOCuota * 100)}%`
        : b["@ImpLocTrasladado"];

    return ordenImpuestos.indexOf(nombreA) - ordenImpuestos.indexOf(nombreB);
  });

  const impuestosTotales = nuevoArrayImpFLOdenado.map((valueImpuesto) => {
    let nombre = "";
    if (valueImpuesto.Impuesto === "002") {
      nombre = "IVA";
    } else if (valueImpuesto.Impuesto === "003") {
      nombre = "IEPS";
    } else {
      nombre = valueImpuesto["@ImpLocTrasladado"]
    }

    if (valueImpuesto.TipoFactor === "Tasa") {
      nombre = nombre + " " + round2Decimals(valueImpuesto.TasaOCuota * 100) + "%";
    } else if (valueImpuesto.TipoFactor === "Cuota") {
      nombre = nombre + " $" + round2Decimals(valueImpuesto.TasaOCuota);
    }

    return { label: nombre, value: dineroDisabledMask(valueImpuesto.Importe || valueImpuesto["@Importe"] || 0) };
  });

  // --- Retenciones (lógica VERBATIM del clásico) ---
  const nuevoArrayRetFL = Array.isArray(dataSat.Impuestos.Retenciones) ?
    [...dataSat.Impuestos.Retenciones, ...(dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.["implocal:RetencionesLocales"] || [])]
    :
    [...(dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.["implocal:RetencionesLocales"] || [])]

  const retencionesTotales = nuevoArrayRetFL.map((valueRetencion) => {
    let nombre = "Retención ";
    if (valueRetencion.Impuesto === "001") {
      nombre = nombre + "ISR";
    } else if (valueRetencion.Impuesto === "002") {
      nombre = nombre + "IVA";
    } else {
      nombre = valueRetencion["@ImpLocRetenido"]
    }

    return { label: nombre, value: dineroDisabledMask(valueRetencion.Importe || valueRetencion["@Importe"]) };
  });

  const totalImpFL = dataSat.Impuestos.TotalImpuestosTrasladados + (dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.["@TotaldeTraslados"] || 0) || 0
  const totalRetFL = dataSat.Impuestos.TotalImpuestosRetenidos + (dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.["@TotaldeRetenciones"] || 0) || 0

  let cancelado = {}
  if (values.estado === 0) {
    cancelado = { watermark: { text: 'CANCELADO', color: 'GRAY', opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 110 } }
  }

  // --- Total y QR fiscal (lógica VERBATIM del clásico) ---
  const total = dataSat.SubTotal - dataSat.Descuento + totalImpFL

  const totalqr = formatQRTotal(dataSat.Total)
  let cadena8 = dataExtra.selloCFDI
  cadena8 = cadena8.slice(-8)

  const linkqr = `https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx?&id=${dataExtra.uuid}&re=${empresa.rfc}&rr=${dataSat.Receptor.Rfc}&tt=${totalqr}&fe=${cadena8}`

  // --- Encabezado de información del documento (columna derecha) ---
  const headerMeta = [
    { label: "N° Factura:", value: (dataSat.Serie ? dataSat.Serie : 'F') + ' - ' + dataSat.Folio },
    { label: "Moneda:", value: dataSat.Moneda },
    { label: "Tipo de Cambio:", value: dineroDisabledMask(dataSat.TipoCambio) },
  ];

  // --- Cliente (identidad del receptor) ---
  const clienteLeft = [
    { label: "Nombre del cliente:", value: dataSat.Receptor.Nombre, strong: true },
    { label: "R.F.C:", value: dataSat.Receptor.Rfc },
    { label: "Uso de CFDI:", value: "(" + dataSat.usoDeCFDI.c_UsoCFDI + ") " + dataSat.usoDeCFDI.descripcion },
    { label: "Forma de pago:", value: "(" + dataSat.formaDePago.c_FormaPago + ") " + dataSat.formaDePago.descripcion },
    { label: "Metodo de pago:", value: dataSat.MetodoPago === "PUE" ? "PUE - Pago en una sola exhibición" : "PPD - Pago en parcialidades o diferido" },
  ];

  const clienteRight = [
    { label: "Fecha:", value: moment(dataSat.Fecha).locale("es").format("LL") },
    { label: "Lugar de expedicion:", value: dataSat.LugarExpedicion },
    { label: "Periodicidad:", value: dataSat.periocidadSat.Clave + " - " + dataSat.periocidadSat.Descripcion },
    { label: "Mes:", value: dataSat.mesSat.Clave + " - " + dataSat.mesSat.Descripcion },
  ];

  // --- Cierre: importe con letra + Uso de CFDI + datos bancarios (izquierda) ---
  const importeLetra = {
    text: [
      { text: "Importe con letra:  ", style: "subheader" },
      { text: "( " + numeroALetra(dataSat.Total, dataSat.Moneda) + " )", style: "textoChico" },
    ],
    margin: [0, 0, 0, 8],
  };

  const paymentRows = [
    { label: "Uso de CFDI:", value: "(" + dataSat.usoDeCFDI.c_UsoCFDI + ") " + dataSat.usoDeCFDI.descripcion },
    { label: "Banco:", value: empresa.banco ? empresa.banco : "" },
    ...(empresa.swiftCode ? [{ label: "Swift Code:", value: empresa.swiftCode ? empresa.swiftCode : "" }] : []),
    ...(empresa.abaCode ? [{ label: "ABA Code:", value: empresa.abaCode ? empresa.abaCode : "" }] : []),
    { label: "Cuenta:", value: empresa.cuentaBanco ? empresa.cuentaBanco : "" },
    { label: "Cuenta CLABE:", value: empresa.cuentaClabe ? empresa.cuentaClabe : "" },
  ];

  const cierreIzquierda = {
    stack: [
      importeLetra,
      PDFPaymentInfoV2({ titulo: "Datos bancarios", rows: paymentRows }),
    ],
  };

  // --- Totales ---
  const totalsRows = [
    { label: "Subtotal:", value: dineroDisabledMask(dataSat.SubTotal) },
    { label: "Descuento:", value: dineroDisabledMask(dataSat.Descuento) },
    ...impuestosTotales,
    { label: "TOTAL:", value: dineroDisabledMask(total), strong: true },
    ...retencionesTotales,
    ...(totalRetFL > 0 ? [{ label: "TOTAL PAGO:", value: dineroDisabledMask(dataSat.Total), strong: true }] : []),
  ];

  // --- Sección resumen (importe/bancos + totales). El QR fiscal va al pie. ---
  const seccionResumen = PDFSummarySectionV2({ left: cierreIzquierda, rows: totalsRows });

  const dd = {
    ...cancelado,
    content: [
      PDFHeaderV2({
        empresa,
        tituloPrincipal: "Factura Global",
        tituloFolio: "N° " + (dataSat.Serie ? dataSat.Serie : "F") + " - " + dataSat.Folio,
        regimenFiscal: true,
        tipoComprobante: "ingreso",
        meta: headerMeta,
      }),
      PDFClientInfoV2({ left: clienteLeft, right: clienteRight }),
      divisorV2(PDF_COLORS.neutralDivider, 7, 1),
      PDFItemsTableV2({ title: buildTitle(), conceptos, widths: buildWidths() }),
      seccionResumen,
      PDFNotesV2(values.imprimirObservaciones && values.observaciones ? values.observaciones : null),
      PDFCfdiFooterV2({ dataExtra, dataSat, qrLink: linkqr }),
    ],
    footer: PDFBrandFooterV2(logoBiwo),
    images: {
      logo: empresa.logo.base64Completa,
    },
    styles: pdfStylesV2(empresa),
    defaultStyle: { font: MULISH_FONT },
    pageSize: "LETTER",
    pageMargins: PDF_PAGE_MARGINS,
  };

  function buildTitle() {
    return [
      { text: "Cantidad", style: "tituloTabla" },
      { text: "Unidad", style: "tituloTabla" },
      { text: "Clave SAT", style: "tituloTabla" },
      { text: "Descripción", style: "tituloTabla", alignment: "left" },
      { text: "IVA", style: "tituloTabla" },
      ...(empresa.imprimirIEPS ? [{ text: "IEPS", style: "tituloTabla" }] : []),
      { text: "P/U", style: "tituloTabla" },
      { text: "Importe", style: "tituloTabla" },
    ];
  }

  function buildWidths() {
    return [
      "8%", // Cantidad
      "6%", // Unidad
      "9%", // Clave SAT
      empresa.imprimirIEPS ? "38%" : "46%", // Descripción
      "8%", // IVA
      ...(empresa.imprimirIEPS ? ["8%"] : []), // IEPS
      "10.5%", // P/U
      "12.5%", // Importe
    ];
  }

  return dd;
};

export default facturaGlobalPdfV2;
